import { FlexProps, Typography } from '@aloft/toolkit-sui';

import { ReactNode } from 'react';

import { CenterLogoLayout } from '../../layout/CenterLogoLayout.tsx';

import './LoadingScreen.scss';

export const LoadingScreen = ({
  what = 'Toolkit',
  lightText,
  overrideText,
  overrideComponent,
  logoSrc,
  logoWidth,
  animationClassName = 'loading-screen-animation-fade-in-out-infinite',
  wrapperProps,
}: {
  what?: string;
  lightText?: boolean;
  overrideText?: string;
  overrideComponent?: ReactNode;
  logoSrc?: string;
  logoWidth?: string;
  animationClassName?: string;
  wrapperProps?: FlexProps;
}) => {
  const message = overrideText || `Loading ${what}...`;
  return (
    <CenterLogoLayout
      animationClassName={animationClassName}
      logoSrc={logoSrc}
      logoWidth={logoWidth}
      {...wrapperProps}
    >
      {overrideComponent || (
        <Typography color={lightText ? 'textOffset' : undefined}>{message}</Typography>
      )}
    </CenterLogoLayout>
  );
};
